(function () {
    'use strict';

    angular.module("imApp").factory("customsTarifLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listCustomsTarifLanguages: function (parms) {
                return $ihttp.post({
                    method: 1730,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1731,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
